import React, { memo } from 'react'
import { Trans } from 'react-i18next'

import { SIGNUP_PROFILE_DISPATCH } from '../../../store/reducers/auth/signup'
import customConfig from 'customConfig'
import CustomCheckbox from '../inputs/CustomCheckbox'
import ExternalLink from '../text/ExternalLink'

const PrivacyPolicyCheckbox = ({
  dispatchAction,
  signupProfile: { error, privacyPolicyAccepted },
  onClickPrivacyPolicy,
  privacyPolicyClickError,
  t
}) => {
  const { acceptPrivacyPolicy, privacyPolicyLabel, privacyPolicyUrl } =
    customConfig
  return (
    <CustomCheckbox
      label={
        <Trans i18nKey={acceptPrivacyPolicy} i18nIsDynamicList>
          <ExternalLink
            label={t(privacyPolicyLabel)}
            to={privacyPolicyUrl}
            onClick={onClickPrivacyPolicy}
            fontWeight='bold'
          />
        </Trans>
      }
      checked={privacyPolicyAccepted}
      onChange={() =>
        dispatchAction(
          SIGNUP_PROFILE_DISPATCH.PRIVACY_POLICY_ACCEPTED,
          !privacyPolicyAccepted
        )
      }
      error={
        error[SIGNUP_PROFILE_DISPATCH.PRIVACY_POLICY_ACCEPTED] ||
        privacyPolicyClickError
      }
    />
  )
}

export default memo(PrivacyPolicyCheckbox)
